module.exports = __webpack_public_path__ + "img/header.80074de8.png";